import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { getSpecialProductStatusColor } from '../../utils/specialProductStatusColors';
import useSpecialProductStatuses from '../../hooks/useSpecialProductStatuses';

const SpecialProductStatus = ({ specialProductId, currentStateId, onStateChange, statusOptions: statusOptionsProp }) => {
  const { statuses: fetchedStatuses, loading } = useSpecialProductStatuses();
  const statusOptions = statusOptionsProp ?? fetchedStatuses;
  const [selectedState, setSelectedState] = useState(currentStateId || '');

  useEffect(() => {
    setSelectedState(currentStateId || '');
  }, [currentStateId]);

  const handleStateChange = (e) => {
    const newStateId = e.target.value;
    setSelectedState(newStateId);
    onStateChange(newStateId);
  };

  if (loading) {
    return <span>Cargando...</span>;
  }

  const selectedStateColor = getSpecialProductStatusColor(selectedState);

  return (
    <Form.Select
      size="sm"
      value={selectedState}
      onChange={handleStateChange}
      style={{ 
        width: 'auto',
        backgroundColor: selectedStateColor.bg,
        color: selectedStateColor.text,
        border: `1px solid ${selectedStateColor.bg}`
      }}
    >
      {statusOptions.map(state => {
        const stateColor = getSpecialProductStatusColor(state.valueId);
        return (
          <option 
            key={state.valueId} 
            value={state.valueId}
            style={{
              backgroundColor: stateColor.bg,
              color: stateColor.text
            }}
          >
            {state.name}
          </option>
        );
      })}
    </Form.Select>
  );
};

export default SpecialProductStatus;